import { render, staticRenderFns } from "./SubobjectView.vue?vue&type=template&id=3f05e290&"
import script from "./SubobjectView.vue?vue&type=script&lang=js&"
export * from "./SubobjectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports